import { createAction, props } from '@ngrx/store';
import {
  ConnectionState,
  IChatAuth,
  IChatMessage,
  JoinChatResponse
} from '@care-portals/api-interfaces';

export const updateChatCount = createAction(
  '[Chat] Get Chat Count',
  props<{ chatId: string; count: number }>()
);

export const startEncounter = createAction(
  '[Chat] Start Encounter',
  props<{ appointmentId: string }>()
);

export const startEncounterSuccess = createAction(
  '[Chat] Start Encounter Success',
  props<{ response: JoinChatResponse }>()
);

export const startEncounterFailure = createAction(
  '[Chat] Start Encounter Failure',
  props<{ error: any }>()
);

export const refreshToken = createAction('[Chat] Refresh Token');

export const refreshTokenSuccess = createAction(
  '[Chat] Refresh Token Success',
  props<{ auth: IChatAuth }>()
);

export const refreshTokenFailure = createAction(
  '[Chat] Refresh Token Failure',
  props<{ error: any }>()
);

export const connectionStateChanged = createAction(
  '[Chat] Connection State Changed',
  props<{ connectionState: ConnectionState }>()
);

export const participantJoined = createAction(
  '[Chat] Participant Joined',
  props<{ participants: any[] }>()
);

export const participantLeft = createAction(
  '[Chat] Participant Left',
  props<{ participants: any[] }>()
);

export const messageAdded = createAction(
  '[Chat] Message Added',
  props<{ chatId: string; message: IChatMessage }>()
);

export const loadMessages = createAction('[Chat] Load Messages');

export const loadMessagesSuccess = createAction(
  '[Chat] Load Messages Success',
  props<{ messages: Array<IChatMessage> }>()
);

export const loadMessagesFailure = createAction(
  '[Chat] Load Messages Fail',
  props<{ error: any }>()
);

export const closeChat = createAction('[Chat] Close Chat');

export const sendMessage = createAction(
  '[Chat] Send Message',
  props<{ message: string, files: any[] }>()
);


export const loadMore = createAction(
  '[Chat] Load More',
);
export const loadMoreSuccess = createAction(
  '[Chat] Load More Success',
  props<{ messages: IChatMessage[] }>()
);
export const loadMoreFailure = createAction(
  '[Chat] Load More Failure',
  props<{ error: any; }>()
);

/// VIDEO ACTIONS

export const joinVideo = createAction('[Chat] Join Video Room',
props<{ joinUrl: string }>()
);

export const joinVideoSuccess = createAction(
  '[Chat] Join Video Room Success',
  props<{ videoRoomId: string }>()
);

export const joinVideoFailure = createAction(
  '[Chat] Join Video Room Failure',
  props<{ error: Error }>()
);

export const leaveRoom = createAction('[Chat] Leave Video Room');

export const leaveRoomSuccess = createAction('[Chat] Leave Video Room');
export const leaveRoomFailure = createAction(
  '[Chat] Leave Video Room Failure',
  props<{ error: Error }>()
);

export const publishVideoTrack = createAction(
  '[Chat] Video Publish Track',
  props<{ track: any }>()
);

export const unpublishVideoTrack = createAction(
  '[Chat] Video Unpublish Track',
  props<{ track: any }>()
);

export const nullAction = createAction('[Chat] Null');
